<div class="card">
  <div class="header">
    <div class="alternative-type-label">
      <ion-icon name="sync" data-cy="alternative-type-label-icon"></ion-icon>
      <span
        *ngIf="originalProduct?.productCardResolutionMsg as resolution"
        [attr.data-cy]="
          'product-detail-' +
          (isReplacement ? 'replacement' : 'substitute') +
          '-text'
        "
        [class.extended-message]="!!resolution?.secondaryText"
        [class.mobile]="
          platformService?.platformType ===
          platformService?.platformEnum?.mobile
        "
      >
        {{ resolution?.primaryText | translate }}
        <span
          *ngIf="!!resolution?.secondaryText"
          class="secondary-text"
          [class.desktop-and-tablet]="
            platformService?.platformType !==
            platformService?.platformEnum?.mobile
          "
        >
          <span>
            {{ resolution?.secondaryText | translate }}
          </span>
          <span *ngIf="!!resolution?.tertiaryText" class="tertiary-text">
            {{ resolution?.tertiaryText | translate }}
          </span>
          <span
            *ngIf="!!resolution?.tertiaryTextDate"
            class="tertiary-text"
            [ngStyle]="resolution?.tertiaryTextDateStyle"
          >
            {{ resolution?.tertiaryTextDate | translate }}
          </span>
        </span>
      </span>
    </div>
  </div>

  <div class="body">
    <div class="left-panel">
      <div class="description-container">
        <a
          class="image-column"
          data-cy="product-image-link"
          (click)="trackProductImageClick(productAlternative?.product)"
          [routerLink]="['../', productAlternative?.product?.productNumber]"
          title="{{
            'i18n.productDetail.replacement.productImage' | translate
          }}"
        >
          <img
            src="{{ thumbnailImageURL }}"
            data-cy="product-image"
            (error)="
              this.thumbnailImageURL =
                getAlternativeThumbnail(thumbnailImageURL)
            "
            *ngIf="!!thumbnailImageURL"
            alt="{{
              'i18n.productDetail.replacement.productImage' | translate
            }}"
          />
          <ion-icon
            name="restaurant"
            *ngIf="!thumbnailImageURL"
            class="no-image"
            data-cy="no-image-icon"
            alt="replacement product image"
          >
          </ion-icon>
        </a>
        <div class="description-column">
          <span
            class="brand"
            [attr.data-cy]="
              'product-brand-' +
              productAlternative?.product?.productNumber +
              '-text'
            "
            >{{
              productAlternative?.product?.summary?.brand | acronymTitleCase
            }}</span
          >
          <a
            class="description"
            data-cy="product-description-text-link"
            [routerLink]="['../', productAlternative?.product?.productNumber]"
            >{{ productAlternative?.product?.summary?.productDescTxtl }}</a
          >
          <div
            class="basic-information"
            data-cy="product-basic-information-text"
          >
            #{{ productAlternative?.product?.summary?.productNumber }}
            <span class="divider" data-cy="divider-line">|</span>
            {{
              productAlternative?.product?.summary?.salesPackSize | lowercase
            }}
          </div>
        </div>
      </div>
      <div class="claim-tags">
        <app-usf-product-tag-list [tagList]="displayTags" [maxTags]="maxTags">
        </app-usf-product-tag-list>
      </div>
    </div>
    <div class="right-panel">
      <div class="inputs-wrapper">
        <div class="input-container">
          <app-quantity-input
            [productNumber]="
              productAlternative?.product?.summary?.productNumber
            "
            [isDisabled]="
              productAlternative?.product?.summary?.properties?.has(
                propertiesEnum.specialOrder
              )
            "
            [isEaches]="false"
            [platform]="currentPlatform"
            [quantity]="orderItem?.unitsOrdered"
            (quantityUpdateEmitter)="changeQuantityHandler($event)"
          ></app-quantity-input>
          <div class="price-container">
            <span
              data-cy="price-details-text"
              *ngIf="
                !pricingDisabled &&
                productAlternative?.product?.pricing?.unitPrice * 1 > 0
              "
            >
              {{
                (productAlternative?.product?.pricing?.unitPrice | currency) ||
                  'i18n.productDetail.loading' | translate
              }}
              {{
                productAlternative?.product?.pricing?.unitPrice
                  ? productAlternative?.product?.summary?.priceUom
                  : ''
              }}</span
            >
            <span
              data-cy="no-price-text"
              *ngIf="
                pricingDisabled ||
                productAlternative?.product?.pricing?.unitPrice * 1 === 0
              "
            >
              {{ 'i18n.lists.noPrice' | translate }}</span
            >
          </div>
        </div>
        <div
          class="input-container"
          *ngIf="productAlternative?.product?.summary?.breakable"
        >
          <app-quantity-input
            [productNumber]="
              productAlternative?.product?.summary?.productNumber
            "
            [isDisabled]="
              productAlternative?.product?.summary?.properties?.has(
                propertiesEnum.specialOrder
              )
            "
            [isEaches]="true"
            [platform]="currentPlatform"
            [quantity]="orderItem?.eachesOrdered"
            (quantityUpdateEmitter)="changeQuantityHandler($event)"
          ></app-quantity-input>
          <div class="price-container">
            <span
              data-cy="price-details-text"
              *ngIf="
                !pricingDisabled &&
                productAlternative?.product?.pricing?.eachPrice * 1 > 0
              "
            >
              {{
                (productAlternative?.product?.pricing?.eachPrice | currency) ||
                  'i18n.productDetail.loading' | translate
              }}
              {{
                productAlternative?.product?.pricing?.eachPrice
                  ? productAlternative?.product?.summary?.catchWeightFlag
                    ? productAlternative?.product?.summary?.priceUom
                    : productAlternative?.product?.summary?.eachUom
                  : ''
              }}
            </span>
            <span
              data-cy="no-price-text"
              *ngIf="
                pricingDisabled ||
                productAlternative?.product?.pricing?.eachPrice * 1 === 0
              "
            >
              {{ 'i18n.lists.noPrice' | translate }}</span
            >
          </div>
        </div>
      </div>

      <div class="action-buttons" *ngIf="hideActionButtons()">
        <!-- Sub / Replace button will be 'removed' until we have an use for it-->
        <ion-button
          class="usf-outline-green-button"
          type="button"
          *ngIf="false"
        >
          <span data-cy="product-replacement-text" *ngIf="isReplacement">
            {{ 'i18n.productDetail.replacement.replace' | translate }}</span
          >
          <span data-cy="product-substitute-text" *ngIf="isSubstitute"
            >Sub</span
          >
        </ion-button>
        <ion-button
          class="usf-outline-green-button"
          type="button"
          [disabled]="isDisable"
          (click)="searchReplacement(isSubstitute)"
        >
          <span
            data-cy="product-search-replacement-text"
            *ngIf="isReplacement"
            >{{
              'i18n.productDetail.replacement.searchReplacement' | translate
            }}</span
          >
          <span data-cy="product-search-substitute-text" *ngIf="isSubstitute">{{
            'i18n.productDetail.replacement.searchSubstitutes' | translate
          }}</span>
        </ion-button>
      </div>
    </div>
    <div class="action-panel">
      <span class="ellipsis-button" (click)="openProductCardOptions($event)">
        <ion-icon
          name="ellipsis-vertical"
          data-cy="action-panel-icon"
        ></ion-icon>
      </span>
    </div>
  </div>
</div>
